
import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import { i18n } from '@/functions';

export default defineComponent({
  props: {
    code: String,
  },
  setup(props) {
    const $store = useStore();
    const errors = computed(() => $store.state.errors);
    const errorText = () => (!props.code
      ? errors.value
        .map((err: string) => (i18n.errors[err] ? i18n.errors[err] : err))
        .join(', ')
      : i18n.errors[props.code] || props.code);
    return {
      errorText,
    };
  },
});
